import { projectRequest } from 'api';
import { ICreateAnnouncementPayload } from './types';

const createAnnouncement = (payload: ICreateAnnouncementPayload) => {
  // Prepare the request payload, omitting target_suppliers if null (all suppliers)
  const { target_suppliers, ...basePayload } = payload;
  
  const requestPayload = target_suppliers === null 
    ? basePayload 
    : { ...basePayload, target_suppliers };
  
  return projectRequest(false, 'v2').post(`/announcement`, requestPayload);
};

export default createAnnouncement;
